/**
 * Wandelt einen String mit Zeilenumbrüchen in HTML-Paragraphen um
 * @param text - Der zu transformierende Text
 * @returns HTML-String mit Paragraphen
 */
export const parseTextToHtmlParagraphs = (text: string | undefined): string => {
  if (!text || typeof text !== 'string') {
    return ''
  }

  if (text.includes('<') && text.includes('>')) {
    return text
  }

  return text
    .split('\n')
    .filter(line => line.trim() !== '')
    .map(line => `<p>${line.trim()}</p>`)
    .join('')
}
